module.exports = __webpack_public_path__ + "media/images/procedure_managements/what_is/img_4-a3230e8b4df237cf7a54ef1479b2a751.png";